<template>
	<div id="container">
		<div id="mapContainer" class="mapContainer"></div>
	</div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import axios from "axios";
import api from "@/store/utils/api";

export default {
	name: "Map",
	props: {
		id: Number,
		mainAddress: String,
		neighborAddresses: Array,
		city: String,
	},

	data() {
		return {
			myMapDiv: null,
			addressCenter: [0, 0],
			offset: 0.01,
		};
	},
	methods: {
		setupLeafletMap: async function (destroy = false) {
			if (document.getElementById("mapContainer") == null) {
				return;
			}
			if (destroy) {
				// this.$delete()
				L.map("mapContainer").remove();
				// document.getElementById("mapContainer").removeChild();
			}
			//positive map center moves left, marker moves right
			// const offset = 0.01;

			//Get address information from google api
			let addressCenter = (await api.get(`/api/v1/property/${this.id}/latlong`)) || [0, 0];
			// console.log("addressCenter", addressCenter);
			this.addressCenter = [addressCenter[0], addressCenter[1]];
			let mapCenter = [addressCenter[0], addressCenter[1]];
			mapCenter[1] -= this.offset;
			const mapOptions = {
				zoomControl: false,
				boxZoom: false,
				doubleClickZoom: false,
				dragging: false,
				keyboard: false,
				scrollWheelZoom: false,
			};
			const mapDiv = L.map("mapContainer", mapOptions).setView(mapCenter, 16);
			this.myMapDiv = mapDiv;
			L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
				// eslint-disable-next-line quotes
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				maxZoom: 18,
			}).addTo(mapDiv);
			var myIcon = L.icon({
				iconUrl: "/img/pin.png",
				iconSize: [51, 62],
				iconAnchor: [25, 62],
				popupAnchor: [-3, -76],
			});
			L.marker(addressCenter, { icon: myIcon }).addTo(mapDiv).bindPopup("Your Home", { closeButton: false });

			if (!!this.neighborAddresses && this.neighborAddresses.length > 0) {
				this.neighborAddresses.forEach(async (addr) => {
					try {
						const point = (await api.get(`/api/v1/property/${addr.id}/latlong`)) || [0, 0];
						// console.log("point", point);
						let circle = L.circle(point, {
							color: "#55A3F8",
							fillColor: "#50CDF3",
							fillOpacity: 0.5,
							radius: 100,
						}).addTo(mapDiv);
						circle.bindPopup("Building SqFt: " + addr.buildingSqFt, { closeButton: false });
						circle
							.bindTooltip(addr.location, {
								direction: "top",
								permanent: true,
								offset: [0, -20],
								className: "map-tooltip",
							})
							.openTooltip();
					} catch (e) {
						console.log(e);
					}
				});
			}
			// const areasPoints = [
			// 	[41.9036254, -87.7264614],
			// 	[41.8986254, -87.7184614],
			// 	[41.9026254, -87.7104614],
			// 	[41.8956254, -87.7264614],
			// ];
			// let counter = 0;
			// areasPoints.forEach((point) => {
			// 	// debugger;
			// 	let circle = L.circle(point, {
			// 		color: "red",
			// 		fillColor: "#f03",
			// 		fillOpacity: 0.5,
			// 		radius: 100,
			// 	}).addTo(mapDiv);
			// 	// circle.bindPopup("Neighbor " + counter + " Approximate Location.");
			// 	circle
			// 		.bindTooltip("Neighbor " + counter + " Approximate Location.", {
			// 			direction: "top",
			// 			permanent: "true",
			// 		})
			// 		.openTooltip();
			// 	counter++;
			// });
		},

		myEventHandler(e) {
			if (window.innerWidth < 768) {
				this.myMapDiv.setView(this.addressCenter, 16);
			} else if (window.innerWidth < 1366) {
				this.myMapDiv.setView(this.addressCenter, 16);
			} else {
				let mapCenter = [this.addressCenter[0], this.addressCenter[1]];
				mapCenter[1] -= this.offset;
				this.myMapDiv.setView(mapCenter, 16);
			}
		},
	},
	mounted() {
		this.setupLeafletMap();
	},
	created() {
		window.addEventListener("resize", this.myEventHandler);
	},
	destroyed() {
		window.removeEventListener("resize", this.myEventHandler);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.mapContainer {
	// height: 100vh;
	height: 94vh;
	.map-tooltip {
		color: white;
		background: #904dff;
		border: unset;
		border-radius: 6px;
		opacity: 0.8 !important;
	}
	.map-tooltip:before {
		border-top-color: #904dff;
	}
}
@media screen and (max-width: 1366px) {
	.mapContainer {
		height: 600px;
	}
}
@media screen and (max-width: 768px) {
	.mapContainer {
		height: 600px;
	}
}
</style>
